function contentScroller() {
  var initContentScroller = function (el, retries) {   
    if (!retries) {
      retries = 0;
    }

    var body = el.find('.content-scroller-body');
    var height = body.height();    
    var innerHeight = body[0].scrollHeight;
    if (innerHeight <= height) {
      if (retries < 5) {
        setTimeout(function () { initContentScroller(el, retries + 1) }, 100);
      }
      return;
    }

    el.addClass('open');
    el.find('.u').click(function () {
      var current = body.scrollTop()      
      var position = current - height;

      body.animate({
        scrollTop: position
      });

      return false;
    });
    el.find('.d').click(function () {
      var current = body.scrollTop()
      console.log(current);
      var position = current + height;
      body.animate({
        scrollTop: position
      }); 

      return false;
    });
  };

  return {
    initContentScroller: initContentScroller
  };
}


(function ($, document, window) {
  $(document).ready(function () {
    $('.content-scroller').each(function (idx, el) {
      var cs = new contentScroller();
      cs.initContentScroller(el);
    });
  });
}(jQuery, document, window));

